import { PARTY_COLORS } from "../lib/api";

export default function PollAverageCard({ data, title }) {
  if (!data || !data.results?.length) {
    return (
      <div className="border border-rule bg-white p-4" data-testid="poll-average-empty">
        <p className="section-eyebrow">{title}</p>
        <p className="mt-3 text-sm text-sub">Sin datos disponibles.</p>
      </div>
    );
  }
  const top = data.results[0]?.average ?? 0;
  return (
    <div className="border border-ink bg-ink text-paper" data-testid="poll-average-card">
      <div className="px-4 pt-4 pb-2 flex items-baseline justify-between border-b border-paper/20">
        <p className="font-mono text-[11px] uppercase tracking-widest text-paper/70">{title}</p>
        <p className="font-mono text-[11px] text-paper/60">
          PROM. ÚLT. {data.polls_used} ENCUESTAS
        </p>
      </div>
      <ul className="px-4 py-3 space-y-2">
        {data.results.map((r) => {
          const color = PARTY_COLORS[r.party] || "#F4F1EB";
          const w = Math.max(2, Math.min(100, (r.average / Math.max(top, 1)) * 100));
          return (
            <li key={r.candidate} data-testid={`avg-row-${r.party}`}>
              <div className="flex items-baseline justify-between">
                <span className="font-sans text-sm font-semibold">{r.candidate}</span>
                <span className="font-mono text-base">{r.average.toFixed(1)}%</span>
              </div>
              <div className="h-[6px] bg-paper/15 mt-1">
                <div className="h-full" style={{ width: `${w}%`, background: color }} />
              </div>
            </li>
          );
        })}
      </ul>
      <div className="px-4 py-2 border-t border-paper/20 font-mono text-[10px] uppercase tracking-widest text-paper/60">
        Casas: {data.pollsters?.join(" · ") || "—"} · Al {data.as_of || "—"}
      </div>
    </div>
  );
}
